import { render } from "./PaymentSlipOutsidePageList.vue?vue&type=template&id=95d7ed52&scoped=true"
import script from "./PaymentSlipOutsidePageList.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipOutsidePageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-95d7ed52"

export default script